
export default function getModelApiConfig() {
    let api_token;
    if (process.env.REACT_APP_SECRET) {
        api_token = process.env.REACT_APP_SECRET;
    } else {
        const encoded_creds = btoa(
            `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
        );
        api_token = `Basic ${encoded_creds}`;
    }

    let baseUrl;
    if (process.env.NODE_ENV === "development") {
        baseUrl = process.env.REACT_APP_HOST_URL;

    } else {
        const hostname = window.location.hostname;
        const protocol = window.location.protocol;
        baseUrl = `${protocol}//${hostname}`
    }



    let baseHeaders;
    if (process.env.NODE_ENV === "development") {
        baseHeaders = {
            authorization: api_token,
        }
    } else {
        baseHeaders = {
            accept: "application/json",
            "accept-language": "en-US,en;q=0.9",
            "cache-control": "no-cache",
            "content-type": "application/json",
            pragma: "no-cache",
            "x-c3-language": "en-US",
            "x-c3-type-aware": "false",
            "x-envelope": "false",
            "x-stream": "false"
        }
    }

    return {
        baseUrl,
        baseHeaders,
        api_token,
    }
}